import React, { Component } from 'react';
// import { formatDate } from '../Utility/utility';

export class Invoice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customerName: props.coNum,
            storeName: props.storeName,
            orderNum: props.orderNumber,
            invoiceNum: props.invoiceNum,
            seq: props.seq,
            invoiceAmount: props.invoiceAmount,
            invoiceDate: props.invoiceDate,
            dueDate: props.dueDate,
            shipDate: props.shipDate,
            paymentAmount: props.paymentAmount,
            debitAmount: props.debitAmt,
            // debitAmount: 3000,
            shipTo: props.shipTo,
            status: props.status,
            guid: props.guid,
            shipmentId : props.shipmentId,
            pod: props.pod
        };
    }
}

export class CreditMemo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customerName: props.custNum,
            storeName: props.caName,
            orderNum: props.coNum,
            invoiceNum: props.invNum,
            invoiceAmount: props.derTcAmtTotal,
            invoiceDate: props.invDate,
            dueDate: props.dueDate,
            type: mapType(props.type)
            // shipDate: props.shipDate,
        };
    }
}

export class Aging extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current: props.current,
            days30: props.days30,
            days60: props.days60,
            days90: props.days90,
            days120: props.days120
        };
    }
}

function mapType(type) {
    switch (type) {
        case "P": return "Payment";
        case "C": return "Credit Memo";
        default: return type;
    }
}

export const hardcodeInvoiceList = [
    {
        "invoiceNumber": "868182",
        "invoiceDate": "1/1/2023",
        "totalAmount": "$100.00",
        "dueDate": "2/1/2023",
        "purchaseOrderNumber": "PO00743210",
        "orderNumber": "CO00743210",
        "shipTo": "John Doe",
        "shipToAddress": "1111 West Ave. Anaheim, CA 92999",
        "status": "Pending",
        "download": ""
    },
    {
        "invoiceNumber": "868183",
        "invoiceDate": "2/1/2023",
        "totalAmount": "$110.00",
        "dueDate": "1/1/2023",
        "purchaseOrderNumber": "PO00743211",
        "orderNumber": "CO00743211",
        "shipTo": "Jane Doe",
        "shipToAddress": "1112 West Ave. Anaheim, CA 92999",
        "status": "Paid",
        "download": ""
    }
]